// src/errors.ts
var PersonnummerError = class extends Error {
  constructor() {
    super("Invalid swedish personal identity number");
  }
};

// src/utils.ts
var compareAsc = (dateLeft, dateRight) => {
  const diff = dateLeft.getTime() - dateRight.getTime();
  return diff < 0 ? -1 : diff > 0 ? 1 : diff;
};
var diffInYears = (dateLeft, dateRight) => {
  const sign = compareAsc(dateLeft, dateRight);
  const yearDiff = Math.abs(dateLeft.getFullYear() - dateRight.getFullYear());
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * yearDiff);
  const isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  const result = sign * (yearDiff - +isLastYearNotFull);
  return result === 0 ? 0 : result;
};
var luhn = (str) => {
  let sum = 0;
  str += "";
  for (let i = 0, l = str.length; i < l; i++) {
    let v = parseInt(str[i]);
    v *= 2 - i % 2;
    if (v > 9) {
      v -= 9;
    }
    sum += v;
  }
  return Math.ceil(sum / 10) * 10 - sum;
};
var testDate = (year, month, day) => {
  month -= 1;
  const date = new Date(year, month, day);
  return !(date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day);
};

// src/index.ts
var Personnummer = class {
  constructor(ssn, options) {
    this._century = "";
    this._fullYear = "";
    this._year = "";
    this._month = "";
    this._day = "";
    this._sep = "";
    this._num = "";
    this._check = "";
    this.parse(ssn, options);
  }
  get century() {
    return this._century;
  }
  get fullYear() {
    return this._fullYear;
  }
  get year() {
    return this._year;
  }
  get month() {
    return this._month;
  }
  get day() {
    return this._day;
  }
  get sep() {
    return this._sep;
  }
  get num() {
    return this._num;
  }
  get check() {
    return this._check;
  }
  static parse(ssn, options) {
    return new Personnummer(ssn, options);
  }
  static valid(ssn, options) {
    try {
      Personnummer.parse(ssn, options);
      return true;
    } catch (e) {
      return false;
    }
  }
  parse(ssn, options) {
    const reg = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([+\-]?)((?!000)\d{3})(\d)$/;
    const match = reg.exec(ssn);
    if (!match) {
      throw new PersonnummerError();
    }
    const century = match[1];
    const year = match[2];
    const month = match[3];
    const day = match[4];
    const sep = match[5];
    const num = match[6];
    const check = match[7];
    if (typeof century === "undefined" || !century.length) {
      const d = new Date();
      let baseYear = 0;
      if (sep === "+") {
        this._sep = "+";
        baseYear = d.getFullYear() - 100;
      } else {
        this._sep = "-";
        baseYear = d.getFullYear();
      }
      this._century = ("" + (baseYear - (baseYear - parseInt(year)) % 100)).substr(0, 2);
    } else {
      this._century = century;
      if (new Date().getFullYear() - parseInt(century + year, 10) < 100) {
        this._sep = "-";
      } else {
        this._sep = "+";
      }
    }
    this._year = year;
    this._fullYear = this._century + year;
    this._month = month;
    this._day = day;
    this._num = num;
    this._check = check;
    if (!this.valid()) {
      throw new PersonnummerError();
    }
  }
  valid() {
    const valid = luhn(this.year + this.month + this.day + this.num) === +this.check && !!this.check;
    if (valid && testDate(parseInt(this.century + this.year), +this.month, +this.day)) {
      return valid;
    }
    return valid && testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
  }
  format(longFormat = false) {
    if (longFormat) {
      return `${this.century}${this.year}${this.month}${this.day}${this.num}${this.check}`;
    }
    return `${this.year}${this.month}${this.day}${this.sep}${this.num}${this.check}`;
  }
  getAge() {
    let ageDay = +this.day;
    if (this.isCoordinationNumber()) {
      ageDay -= 60;
    }
    const ageDate = this.century + this.year + "-" + this.month + "-" + (ageDay < 10 ? "0" + ageDay : ageDay);
    return diffInYears(new Date(Date.now()), new Date(ageDate));
  }
  isCoordinationNumber() {
    return testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
  }
  isFemale() {
    return !this.isMale();
  }
  isMale() {
    const sexDigit = parseInt(this.num.substr(-1));
    return sexDigit % 2 === 1;
  }
};
var src_default = Personnummer;
export {
  src_default as default
};
